import React, { useEffect } from "react";
import _ from "lodash";

import {
  IFormOption,
  Select
} from "src/library/components/Forms";

import {
  useProductApprovalApi,
  ProductApprovalRequestName
} from "../api/product-approval.api";

interface ProductApprovalDropdown {
  updateSelectedProductApprovalList: (productApprovalId: number | null) => void;
  additionalOptions?: IFormOption[];
  value?: number | null;
  disabled?: boolean;
}

const ProductApprovalDropdown: React.ReactFCWithChildren<ProductApprovalDropdown> = ({
  updateSelectedProductApprovalList, additionalOptions = [], value, disabled
}) => {
  const [ approvalListResponse, getApprovalList ] = useProductApprovalApi(ProductApprovalRequestName.LIST_APPROVAL_LISTS);

  useEffect(() => {
    getApprovalList({
      pagination: {
        sort: [ [ "description", "ASC" ] ],
        page: 0,
        limit: 1000,
        offset: 0
      },
      filters: {}
    });
  }, [ getApprovalList ]);

  return (
    <Select
      disabled={disabled}
      as="select"
      options={approvalListResponse.data?.result ?
        [
          ..._.map(approvalListResponse.data.result, approvalItem => ({
            text: `${approvalItem.name} - ${approvalItem.description}`,
            value: approvalItem.id.toString()
          })),
          ...additionalOptions
        ] :
        []}
      handleChange={e => {
        if (e.target.value.length) {
          updateSelectedProductApprovalList(parseInt(e.target.value, 10));
        } else {
          updateSelectedProductApprovalList(null);
        }
      }}
      name="Accepted Product List"
      label="Accepted Product List"
      value={value}
      unselectedOption={{
        text: "Please select (optional)",
        value: ""
      }}
    />
  );
};

export default ProductApprovalDropdown;
